import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

export default function CommonLoading(props) {
    const classes = useStyles();

    const { isLoading = false } = props

    return (
        <Backdrop className={classes.backdrop} open={isLoading}>
            <CircularProgress color='inherit' />
        </Backdrop>
    );
}